import React from "react";
import "./Impression.css";

const Imp = () => {

    return (
        <div id="impression" className="impression">
            <div className="imp-block">
                <div className="imp-title" />
                <div className="imp-title-resp">
                    Salon Calm
                </div>
                <a href="https://page.line.me/474qslor" target="_blank" rel="noreferrer" className="book">ご予約はこちらから</a>
            </div>
        </div>
    )
}

export default Imp